import React from "react";
import { CheckIcon, FlameIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { CountdownTimer } from "../CountdownTimer";
import { ScarcityBar } from "../ScarcityBar";
import { images, offerIncludes, valueStack } from "../../data/content";
export function Offer() {
  const total = valueStack.reduce((sum, v) => sum + v.value, 0);
  return <section id="offer" className="bg-cream px-4 py-16 sm:px-6 sm:py-24" aria-labelledby="offer-title" data-id="element-233" data-mp="3a5ys809e434x">
      <div className="mx-auto max-w-3xl text-center" data-id="element-234" data-mp="3f407ea3p3ib4">
        <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide text-danger" data-id="element-235" data-mp="3f2ffks8rmdgy">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-236" data-mp="3nwu3tkb9wyc7" />
          Special digital edition offer
        </p>
        <h2 id="offer-title" className="mt-3 font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-237" data-mp="3sw6r266247fb">
          Everything You Need to Organize Mandibular Complete Denture Cases in One Clinical Reference System
        </h2>
      </div>

      <div className="mx-auto mt-10 max-w-2xl overflow-hidden rounded-[28px] bg-white shadow-[0_30px_60px_-25px_rgba(10,29,64,0.45)] ring-2 ring-navy-900" data-id="element-238" data-mp="1kn1di2tr3jek">
        <div className="bg-navy-900 px-5 pb-6 pt-7 text-center text-white sm:px-8" data-id="element-239" data-mp="1bka2g44sepng">
          <p className="font-display text-sm font-extrabold uppercase tracking-[0.15em] text-gold-400" data-id="element-240" data-mp="16lyr1oyug734">
            Your complete professional collection
          </p>
          <img src={images.mockup} alt="Complete Blueprint collection" className="mx-auto mt-5 w-full max-w-md" data-id="element-241" data-mp="23e2curys9gyn" />
        </div>

        <div className="px-5 py-7 sm:px-8" data-id="element-242" data-mp="1uje9j7crq9ch">
          <ul className="divide-y divide-navy-900/10" data-id="element-243" data-mp="1uicvcu0gh6qj">
            {valueStack.map(v => <li key={v.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-244" data-mp="1pjruqthakl1k">
                <span className="flex gap-2.5 text-base font-medium leading-snug text-ink" data-id="element-245" data-mp="2n10bdv0lhvkr">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-246" data-mp="2i878zdslmzbu" />
                  {v.label}
                </span>
                <span className="shrink-0 font-bold tabular-nums text-muted line-through" data-id="element-247" data-mp="364k9xr9bxq2j">${v.value}</span>
              </li>)}
            <li className="flex items-center justify-between gap-4 py-4" data-id="element-248" data-mp="2sc46wqgfhs1m">
              <span className="font-display text-base font-black uppercase text-ink" data-id="element-249" data-mp="2we8v39o3xwgv">Total suggested value</span>
              <span className="font-display text-xl font-black tabular-nums text-danger line-through" data-id="element-250" data-mp="2iepy9d0qy7jv">${total}</span>
            </li>
          </ul>

          <div className="mt-4 rounded-3xl bg-navy-950 px-5 py-7 text-center text-white" data-id="element-251" data-mp="2nbznark84h76">
            <p className="text-sm font-bold uppercase tracking-wide text-white/70" data-id="element-252" data-mp="29g48awsy3q92">Your price today</p>
            <p className="mt-1 text-lg font-semibold text-white/60 line-through" data-id="element-253" data-mp="2dhz8tz31xzls">${total}</p>
            <p className="mt-1 font-display font-black leading-none text-gold-400" data-id="element-254" data-mp="7npsc39yovva">
              <span className="align-top text-3xl" data-id="element-255" data-mp="bnzyph1o1oao">$</span>
              <span className="text-[84px] sm:text-[100px]" data-id="element-256" data-mp="1w62fwcskttfy">27</span>
              <span className="ml-1 text-2xl" data-id="element-257" data-mp="1w47u6w9hdxat">USD</span>
            </p>
            <p className="mt-3 font-display text-base font-extrabold uppercase" data-id="element-258" data-mp="1s6jvdi4o3kdn">One-time payment</p>
            <p className="mt-1 text-sm text-white/70" data-id="element-259" data-mp="25xydlmqr3hjn">No monthly subscriptions. No recurring charges.</p>
          </div>

          <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-260" data-mp="213kg9esj30cc">
            {offerIncludes.map(item => <li key={item} className="flex gap-2.5 text-base leading-snug text-ink" data-id="element-261" data-mp="2fwe7tyl2r6xd">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-262" data-mp="2axkse0m895uk" />
                {item}
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-263" data-mp="2jwoap2dklh80">
            <CtaButton label="Get instant access for just $27" data-id="element-264" data-mp="2jubtirfmzaw0" />
          </div>

          <div className="mt-8" data-id="element-265" data-mp="ujb394a5vd2o">
            <CountdownTimer tone="light" label="Your special offer ends in" data-id="element-266" data-mp="pidnszgjcx4v" />
          </div>

          <div className="mt-8" data-id="element-267" data-mp="rx2celfoy9lm">
            <ScarcityBar data-id="element-268" data-mp="rvqz9v0cvphu" />
          </div>

          <div className="mt-7 space-y-3 rounded-2xl bg-cream p-4" data-id="element-269" data-mp="rz50gzxa9snp">
            <p className="flex gap-2.5 text-sm leading-snug text-ink" data-id="element-270" data-mp="vwsyibu9w1jt">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-271" data-mp="10x77bw3p7fiw" />
              <span data-id="element-272" data-mp="15x3c3xk7zazi">
                <strong data-id="element-273" data-mp="15v8qsi51dguw">Automatic currency conversion:</strong> pay from any country — the $27 USD price is converted
                to your local currency automatically at checkout.
              </span>
            </p>
            <p className="flex gap-2.5 text-sm leading-snug text-ink" data-id="element-274" data-mp="d8fp9xjtodju">
              <LockIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-275" data-mp="i5xxflq0moqs" />
              <span data-id="element-276" data-mp="mxz50uc8nrah">Secure checkout · Instant digital access · Lifetime access</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}